import {
    guideClickOnElement,
    guideWaitForElement,
    guideClickOnElementInTopActivity,
    guideFillInput,
    guideWaitForElementLong,
    guideWaitForValue,
    guideDoubleClickOnElement
} from "@/components/dashboard/guides/guidNavigation";

import {isBelowBreakpoint} from "@/utils/Dom";
import EventBus from "@/utils/EventBus";

export function AIInpaintTutorialGuideFromView(initialMenu) {
    let menu = initialMenu;

    return [
        {
            target: '#dark-navbar',
            header: {
                title: 'Hello There',
            },
            content: "I’ll guide you through usage of AI Retouch. Let’s get started!",
            imageSrc: "https://silkplm.com/wp-content/uploads/2024/11/Product-Tour-welcome-screen.png",
            beforeNext: async() => {
                if(isBelowBreakpoint("md")) {
                    EventBus.$emit('openMainMenu');
                    menu = "mobile-";
                } else {
                    menu = "";
                }
            }
        },
        {
            target: () => ".activity-top .hdr-pb",
            previous: true,
            content: "This is a AI Retouch component. Here you can change the image to your liking. Paint over the areas you want to change and write a prompt to replace the painted part.",
        },
        {
            target: () => ".activity-top [data-test-path='paint-size']",
            previous: true,
            content: "Here you can change the size of the paintbrush from small, medium to large.",
        },
        {
            target: () => ".activity-top [data-test-path='zoom']",
            previous: true,
            content: "You can zoom in, zoom out or reset the size of image to make it easier to paint.",
        },
        {
            target: () => ".activity-top [data-test-path='show-tooltip']",
            previous: true,
            content: "Here is a tooltip with additional information if you do not know what to do.",
        },
        {
            target: () => ".activity-top [data-test-path='write-prompt']",
            previous: true,
            content: "Now, click here for prompt.",
            beforeNext: async () => {
                await guideClickOnElement(".activity-top [data-test-path='write-prompt']")
                await guideWaitForElement(".activity-top [data-test-path='prompt']")
                await sleep(500);
            }
        },
        {
            target: () => ".activity-top [data-test-path='prompt']",
            previous: true,
            content: "Here you write a prompt to replace the painted part with something you want.",
            previousStep: async () => {
                await guideClickOnElement(".activity-top [data-test-path='write-prompt']")
                await sleep(500);
            }
        },
        {
            target: () => ".activity-top [data-test-path='details-button']",
            previous: true,
            content: "In the end, you click here to generate new image.",
        },
        {
            target: () => ".activity-top img",
            previous: true,
            content: "That is all for now. Feel free to experiment with it.",
        },
    ];
}
